// Generated by tools/scripting/generate_native_dialogue_progress_index_data.py.
// Do not hand-edit; regenerate from verified progress evidence.
export const NATIVE_DIALOGUE_PROGRESS_INDEX_DATA = Object.freeze({
  "schema": "new-yokosuka-native-dialogue-progress-index-v1",
  "generatedFrom": {
    "schema": "new-yokosuka-dialogue-progress-state-v1",
    "executableSha256": "ca98879a97df87b668836bbfa597d38c6f9efc3fd45160208b8d5d866325f32c",
    "runtimeAddress": "0xc278d08"
  },
  "fixedIdentities": [
    "AKIR",
    "SORY",
    "IWAO",
    "JAKR",
    "FUKU",
    "INE_",
    "KISY",
    "TAIJ",
    "CHAI",
    "KURA",
    "KURB",
    "KAME",
    "JIMY",
    "TONY",
    "SMTH",
    "AKMI",
    "YOKO",
    "YUKK",
    "SYZU",
    "JUKY",
    "OISI",
    "NAMS",
    "SETA",
    "MTUK",
    "HORS",
    "SNKC",
    "YOSE",
    "MRIG",
    "NITO",
    "TSUC",
    "HATO",
    "ITOI",
    "TURU",
    "KURI",
    "AOKI",
    "MADA",
    "ETKO",
    "BUSS",
    "TOM_",
    "HIRA",
    "HISA",
    "YURI",
    "NANS",
    "HRKO",
    "AKSK",
    "MRUA",
    "HOND",
    "ONRR",
    "TATM",
    "KYUR",
    "UNO_",
    "KYOH",
    "ASDA",
    "YAMA",
    "MISM",
    "KOND",
    "RNKT",
    "NORK",
    null,
    "YNHS",
    "KKBN",
    "YOPA",
    "CATM",
    "KJIY",
    null,
    "EIIU",
    "PEDR",
    "PAUR",
    "TOM1",
    "KEBA",
    "KEBB",
    "KEBC",
    "KEBD",
    "STP1",
    "SAGA",
    "MSYU",
    "RYBI",
    "KYAS",
    "SIIN",
    "SKGK",
    null,
    "KIM_",
    null,
    "MIKM",
    "NSMR",
    "TKYM",
    "MTUR",
    "EDST",
    "MYKN",
    "TMNY",
    "MYTY",
    "HROT",
    "KYKW",
    "MWAK",
    "MKII",
    "HREO",
    "SCKO",
    "EIKK",
    "KUKT",
    "JOHN",
    null,
    "CMAL",
    "SATM",
    "BIKA",
    "BIKB",
    "TMMR",
    "MEYS",
    "TYHG",
    "KJHS",
    "TYMK",
    null,
    null,
    "SIND",
    "MASR",
    "ONO_",
    "MIKI",
    "HATR",
    null,
    "YAMO",
    "NOMR",
    "MEGM",
    "MAYM",
    "YKDM",
    "YOS1",
    "YOS2",
    "YOB1",
    "YOB2",
    "YJJI",
    "YBBA",
    "SUMI",
    "KOMN",
    "SAJO",
    null,
    "SKMT",
    "KOTA",
    "YASU",
    "KAYO",
    null,
    null,
    null,
    null,
    "TTYA",
    "SOBA",
    "ASOU",
    "HINA",
    "YSHY",
    "MJNT",
    null,
    "KKEN",
    "TKNB",
    "TOSK",
    "SERA",
    "HMRO",
    "BSJM",
    "BOB_",
    "FKSM",
    "KJMA",
    "NRSK",
    "ASNO",
    "NAKA",
    "NMKI",
    "YMGC",
    "KOGA",
    "TMRA",
    "MITA",
    "YAYI",
    "HTSI",
    "JOE_",
    "SAKI",
    "MIHO",
    "ENDO",
    "YOSI",
    "TKSA",
    "TAGW",
    "RYKO",
    "IRIE",
    "KURT",
    "HANA",
    "SIMZ",
    null,
    "TTAY",
    "DICK",
    "MARK",
    "RBRT",
    "HARY",
    "JONZ",
    "TAKI",
    "HIRI",
    "TAKE",
    "AKTG",
    "TOKI",
    "KNJI",
    "RIKA",
    "STSI",
    "GORO",
    "MKMR",
    "TDSI",
    "HRNO",
    null,
    "KUDO",
    "MURI",
    "FLD1",
    "FLD2",
    "FLD3",
    "FLD4",
    "FLD5",
    "FLD6",
    "FLD7",
    "FLD8",
    "FLD9",
    "FLDA",
    "FLDB",
    "FLDC",
    "FLDD",
    "KEBE",
    "KEBF",
    "KEBG",
    "KEBH",
    "KEBI",
    "KEBJ",
    "KEBK",
    "KEBL",
    "YOHI",
    "NGAI",
    "ITOH",
    "SKRD",
    "YJIH",
    "TJMA",
    "JONO",
    "UDGW",
    "OKYS",
    "ISDA",
    "MURA",
    "SNGA",
    "MITI",
    "MSTA",
    "MRSK",
    "MNWA",
    "HTNK",
    "HRSK",
    "NMNO",
    "ISYM",
    "KYMA",
    "ENKI",
    "NGSM",
    "TKHS",
    "HIDE",
    "KTRO",
    "KENI",
    "KYHN",
    "YMST",
    "SNDO",
    "NMTO",
    "KWMT",
    "TAEN",
    "SZEN",
    "KYSN",
    "SATO",
    "YSKT",
    "STAK",
    "IZWA",
    null,
    "SGRH",
    "MTRI",
    "TERY",
    "YKHI",
    "SBNK",
    "DTRY",
    null,
    null,
    "RINS",
    "ECHO",
    null,
    null,
    "RKKI",
    null,
    "GRKN",
    "MAGO",
    "CHRL",
    null,
    "MORN",
    "HDEI",
    "TEYI",
    "TOMH",
    "FLDE",
    "FLDF",
    "FLDG",
    "TMHN",
    "DJUN",
    null,
    "HSOA",
    "GJHM",
    "GJBM",
    "GJHF",
    "GJBF",
    "YUMM",
    "SYKU",
    "HTSK",
    "SMIK",
    "SNJY",
    "SINF"
  ],
  "indexByIdentity": {
    "AKIR": 0,
    "SORY": 1,
    "IWAO": 2,
    "JAKR": 3,
    "FUKU": 4,
    "INE_": 5,
    "KISY": 6,
    "TAIJ": 7,
    "CHAI": 8,
    "KURA": 9,
    "KURB": 10,
    "KAME": 11,
    "JIMY": 12,
    "TONY": 13,
    "SMTH": 14,
    "AKMI": 15,
    "YOKO": 16,
    "YUKK": 17,
    "SYZU": 18,
    "JUKY": 19,
    "OISI": 20,
    "NAMS": 21,
    "SETA": 22,
    "MTUK": 23,
    "HORS": 24,
    "SNKC": 25,
    "YOSE": 26,
    "MRIG": 27,
    "NITO": 28,
    "TSUC": 29,
    "HATO": 30,
    "ITOI": 31,
    "TURU": 32,
    "KURI": 33,
    "AOKI": 34,
    "MADA": 35,
    "ETKO": 36,
    "BUSS": 37,
    "TOM_": 38,
    "HIRA": 39,
    "HISA": 40,
    "YURI": 41,
    "NANS": 42,
    "HRKO": 43,
    "AKSK": 44,
    "MRUA": 45,
    "HOND": 46,
    "ONRR": 47,
    "TATM": 48,
    "KYUR": 49,
    "UNO_": 50,
    "KYOH": 51,
    "ASDA": 52,
    "YAMA": 53,
    "MISM": 54,
    "KOND": 55,
    "RNKT": 56,
    "NORK": 57,
    "YNHS": 59,
    "KKBN": 60,
    "YOPA": 61,
    "CATM": 62,
    "KJIY": 63,
    "EIIU": 65,
    "PEDR": 66,
    "PAUR": 67,
    "TOM1": 68,
    "KEBA": 69,
    "KEBB": 70,
    "KEBC": 71,
    "KEBD": 72,
    "STP1": 73,
    "SAGA": 74,
    "MSYU": 75,
    "RYBI": 76,
    "KYAS": 77,
    "SIIN": 78,
    "SKGK": 79,
    "KIM_": 81,
    "MIKM": 83,
    "NSMR": 84,
    "TKYM": 85,
    "MTUR": 86,
    "EDST": 87,
    "MYKN": 88,
    "TMNY": 89,
    "MYTY": 90,
    "HROT": 91,
    "KYKW": 92,
    "MWAK": 93,
    "MKII": 94,
    "HREO": 95,
    "SCKO": 96,
    "EIKK": 97,
    "KUKT": 98,
    "JOHN": 99,
    "CMAL": 101,
    "SATM": 102,
    "BIKA": 103,
    "BIKB": 104,
    "TMMR": 105,
    "MEYS": 106,
    "TYHG": 107,
    "KJHS": 108,
    "TYMK": 109,
    "SIND": 112,
    "MASR": 113,
    "ONO_": 114,
    "MIKI": 115,
    "HATR": 116,
    "YAMO": 118,
    "NOMR": 119,
    "MEGM": 120,
    "MAYM": 121,
    "YKDM": 122,
    "YOS1": 123,
    "YOS2": 124,
    "YOB1": 125,
    "YOB2": 126,
    "YJJI": 127,
    "YBBA": 128,
    "SUMI": 129,
    "KOMN": 130,
    "SAJO": 131,
    "SKMT": 133,
    "KOTA": 134,
    "YASU": 135,
    "KAYO": 136,
    "TTYA": 141,
    "SOBA": 142,
    "ASOU": 143,
    "HINA": 144,
    "YSHY": 145,
    "MJNT": 146,
    "KKEN": 148,
    "TKNB": 149,
    "TOSK": 150,
    "SERA": 151,
    "HMRO": 152,
    "BSJM": 153,
    "BOB_": 154,
    "FKSM": 155,
    "KJMA": 156,
    "NRSK": 157,
    "ASNO": 158,
    "NAKA": 159,
    "NMKI": 160,
    "YMGC": 161,
    "KOGA": 162,
    "TMRA": 163,
    "MITA": 164,
    "YAYI": 165,
    "HTSI": 166,
    "JOE_": 167,
    "SAKI": 168,
    "MIHO": 169,
    "ENDO": 170,
    "YOSI": 171,
    "TKSA": 172,
    "TAGW": 173,
    "RYKO": 174,
    "IRIE": 175,
    "KURT": 176,
    "HANA": 177,
    "SIMZ": 178,
    "TTAY": 180,
    "DICK": 181,
    "MARK": 182,
    "RBRT": 183,
    "HARY": 184,
    "JONZ": 185,
    "TAKI": 186,
    "HIRI": 187,
    "TAKE": 188,
    "AKTG": 189,
    "TOKI": 190,
    "KNJI": 191,
    "RIKA": 192,
    "STSI": 193,
    "GORO": 194,
    "MKMR": 195,
    "TDSI": 196,
    "HRNO": 197,
    "KUDO": 199,
    "MURI": 200,
    "FLD1": 201,
    "FLD2": 202,
    "FLD3": 203,
    "FLD4": 204,
    "FLD5": 205,
    "FLD6": 206,
    "FLD7": 207,
    "FLD8": 208,
    "FLD9": 209,
    "FLDA": 210,
    "FLDB": 211,
    "FLDC": 212,
    "FLDD": 213,
    "KEBE": 214,
    "KEBF": 215,
    "KEBG": 216,
    "KEBH": 217,
    "KEBI": 218,
    "KEBJ": 219,
    "KEBK": 220,
    "KEBL": 221,
    "YOHI": 222,
    "NGAI": 223,
    "ITOH": 224,
    "SKRD": 225,
    "YJIH": 226,
    "TJMA": 227,
    "JONO": 228,
    "UDGW": 229,
    "OKYS": 230,
    "ISDA": 231,
    "MURA": 232,
    "SNGA": 233,
    "MITI": 234,
    "MSTA": 235,
    "MRSK": 236,
    "MNWA": 237,
    "HTNK": 238,
    "HRSK": 239,
    "NMNO": 240,
    "ISYM": 241,
    "KYMA": 242,
    "ENKI": 243,
    "NGSM": 244,
    "TKHS": 245,
    "HIDE": 246,
    "KTRO": 247,
    "KENI": 248,
    "KYHN": 249,
    "YMST": 250,
    "SNDO": 251,
    "NMTO": 252,
    "KWMT": 253,
    "TAEN": 254,
    "SZEN": 255,
    "KYSN": 256,
    "SATO": 257,
    "YSKT": 258,
    "STAK": 259,
    "IZWA": 260,
    "SGRH": 262,
    "MTRI": 263,
    "TERY": 264,
    "YKHI": 265,
    "SBNK": 266,
    "DTRY": 267,
    "RINS": 270,
    "ECHO": 271,
    "RKKI": 274,
    "GRKN": 276,
    "MAGO": 277,
    "CHRL": 278,
    "MORN": 280,
    "HDEI": 281,
    "TEYI": 282,
    "TOMH": 283,
    "FLDE": 284,
    "FLDF": 285,
    "FLDG": 286,
    "TMHN": 287,
    "DJUN": 288,
    "HSOA": 290,
    "GJHM": 291,
    "GJBM": 292,
    "GJHF": 293,
    "GJBF": 294,
    "YUMM": 295,
    "SYKU": 296,
    "HTSK": 297,
    "SMIK": 298,
    "SNJY": 299,
    "SINF": 300
  },
  "dynamicIndexStart": 301,
  "dynamicIndexCount": 24
});
